var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 48,
    viewBox: "0 0 68 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 47.8124L27.876 1.17188L47.5857 36.2689L40.8814 47.8124H21.033L24.8136 41.1207L24.1961 42.2549L36.5462 42.1541L40.3899 35.7018L27.9642 13.8748L8.01495 47.6612L3.37737 47.8124H0Z",
    fill: "#1E4397"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0356 47.8125H13.1719L28.2945 21.7891L31.8483 28.3926L24.8163 41.1208L21.0356 47.8125Z",
    fill: "#FED100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7422 8.8215L40.0099 0L67.6086 47.8126H44.9625L47.7224 42.4441L58.1065 42.1668L40.4383 11.2663L38.5606 15.236L34.7422 8.8215Z",
    fill: "#FED100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d165a3875640717d29f9aa1aff15d083.svg";
export { ForwardRef as ReactComponent };